import { render, staticRenderFns } from "./DuaMessageCancellationFields.vue?vue&type=template&id=43828ff0"
import script from "./DuaMessageCancellationFields.vue?vue&type=script&lang=js"
export * from "./DuaMessageCancellationFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports